export const ERROR_DELIMITER = ' <<<<<<HUMAN|DETAILED>>>>> '
export const ERROR_STATUS_PREFIX = '[[-'
export const ERROR_STATUS_POSTFIX = '-]]'
